import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { ApplicationStatus, FocusPayPreApp, PreAppActivityHistory } from 'src/app/shared/models/FocusPay/FocusPayPreApp.dto';

@Component({
	selector: 'app-application-single-view',
	templateUrl: './application-single-view.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class ApplicationSingleViewComponent implements OnInit {
	preApp: FocusPayPreApp;

	applicationStatusList: GenericLabelValue[] = [];

	currentApplicationStatus: string;

	timelineEvents: {
		status: string;
		date: string;
	}[] = [];

	constructor(
		public app: AppService,
		private userService: UserService,
		private focuslink: FocuslinkService,
		private router: Router,
		private activatedRouter: ActivatedRoute
	) {}

	ngOnInit(): void {
		const preAppKey = this.activatedRouter.snapshot.paramMap.get('applicationKey');
		this.getApplication(preAppKey);
		Object.keys(ApplicationStatus).forEach((key) => {
			if (isNaN(+key)) {
				this.applicationStatusList.push(
					new GenericLabelValue({
						value: key,
						label: ApplicationStatus[key],
					})
				);
			}
		});
	}

	async getApplication(appKey: string) {
		this.app.loading(true);
		const resp = await this.focuslink.focuspayPreAppGetOne(appKey);
		this.preApp = new FocusPayPreApp(resp);
		this.currentApplicationStatus = this.preApp.status;
		this.app.loading(false);
	}

	async onStatusChange() {
		this.app.loading(true);
		this.preApp.activityHistory.push(
			new PreAppActivityHistory({
				user: `${this.userService.userSubscription.value.firstName} ${this.userService.userSubscription.value.lastName}`,
				originalStatus: this.currentApplicationStatus,
				newStatus: this.preApp.status,
				dateTime: this.app.moment().format(),
			})
		);

		this.currentApplicationStatus = this.preApp.status;

		try {
			await this.focuslink.focuspayPreAppPatch(this.preApp.sk, this.preApp);
			this.preApp.activityHistory = [...this.preApp.activityHistory];
			this.app.loading(false);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Application status updated` });
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error updating application status` });
		}
		this.app.loading(false);
	}

	back() {
		this.router.navigate(['cc/payments/focuspay/applications']);
	}
}
